/* eslint-disable no-unused-vars */
import React, { useState, useContext, useEffect } from "react";
import { Container } from "react-bootstrap"; // Keep Container from react-bootstrap
import { Link } from "react-router-dom";
import OrderUserContext from "../OrderUserContext";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
} from "@mui/material"; // MUI table and pagination components

export default function CustomersList() {
  const [currentPage, setCurrentPage] = useState(1);
  const CustomersPerPage = 10;
  const { customer, loading } = useContext(OrderUserContext);
  const indexOfLastOrder = currentPage * CustomersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - CustomersPerPage;
  const totalPages = Math.ceil(customer.length / CustomersPerPage);
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage + 1); // MUI pagination uses 0-based index, so it will automatically adjust
  };

  return (
    <div>
      <div className="all-products">
        <Container fluid>
          <div className="products-page-heading">
            <h1>Customers</h1>
          </div>
          <div

          
            className="all-product-list mb-1"
            style={{ height: "73vh", overflowY: "auto" ,overflowX:"auto"}}
          >
            <Table className=" mt-1">
              <TableHead className="thead-box">
                <TableRow
                  className="border-b-2"
                  style={{ borderBottom: "2px solid gray" }}
                >
                  <TableCell style={{ fontWeight: "bold", fontSize: "20px" }}>
                    #
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", fontSize: "20px" }}>
                    Name
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", fontSize: "20px" }}>
                    Email
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", fontSize: "20px" }}>
                    City
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", fontSize: "20px" }}>
                    Orders
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", fontSize: "20px" }}>
                    Total Amount Spent
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {customer.length > 0 ? (
                  customer
                    .slice(indexOfFirstOrder, indexOfLastOrder)
                    .map((item, index) => (
                      <TableRow
                        key={item.userId}
                        sx={{
                          borderBottom: "1.5px solid gray",
                          backgroundColor:
                            (indexOfFirstOrder + index) % 2 === 0
                              ? "#f2f2f2 !important"
                              : "#ffffff !important",
                        }}
                      >
                        <TableCell>{indexOfFirstOrder + index + 1}.</TableCell>
                        <TableCell>
                          <Link
                            to={`/customer-details/${item.customerId}`}
                            className="text-decoration-none"
                          >
                            {item?.orders
                              .slice(0, 1)
                              .map(
                                (order) =>
                                  order.deliveryAddress?.name || item.name
                              )}
                          </Link>
                        </TableCell>
                        <TableCell>
                          {item?.orders
                            .slice(0, 1)
                            .map(
                              (order) =>
                                order.deliveryAddress?.email || item.email
                            )}
                        </TableCell>
                        <TableCell>
                          {item.orders
                            .slice(0, 1)
                            .map((order) => order.deliveryAddress.city)}
                        </TableCell>
                        <TableCell>{item.orders.length}</TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>
                          {item.orders
                            .reduce((acc, order) => acc + order.totalPrice, 0)
                            .toLocaleString("en-in", {
                              style: "currency",
                              currency: "INR",
                            })}
                          /-
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6}>
                      <div className="sweet-loading w-[100%] h-[100vh]">
                        <p>No Data found</p>
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <div className="pagination-controls d-flex justify-content-between align-items-center mt-4">
              <div></div>
              <TablePagination
                rowsPerPageOptions={[CustomersPerPage, 25, 50]}
                component="div"
                count={customer.length}
                rowsPerPage={CustomersPerPage}
                page={currentPage - 1} // Adjust for 0-based index
                onPageChange={handlePageChange}
                color="primary"
                variant="outlined"
                shape="rounded"
                className="actions"
              />
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
}
